
export default {
  props: {
    player: {
      type: Object,
      default: null,
    },
    playerIndex: {
      type: Number,
      required: true,
    },
    disabledClick: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
    };
  },
  computed: {
    isActive () {
      return this.$parent.activePlayerIndex === this.playerIndex;
    },
    playerName () {
      return this.getKnownAs(this.player.player);
    },
    playerLastName () {
      return this.getKnownAs(this.player.player, true);
    },
  },
  methods: {
    setActivePlayer () {
      if (this.disabledClick) {
        return;
      }
      this.$parent.activePlayerIndex = this.playerIndex;
    },
  },
};
